// extracted by mini-css-extract-plugin
export default {"startappblog":"d6e5b2812b110dd7a3f2","optionsection":"cb8ae1d1e3e631cc2b64"};